import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AuthService, Block, BlockAbstractComponent, CacheService, ParserService} from '@gallaghercp/core-frontend';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {ClientService} from '../../services/client.service';
import {ActivatedRoute, Router} from '@angular/router';

const WIDGET_ID = 49;

export class PageCategory {
    id!: number;
    name!: string;
    pages$!: Observable<any>;
    pagesLoading!: boolean;
}

export class Page {
    id!: number;
    widgets!: [];
    tile?: Block;
}

@Component({
    standalone: false,
    selector: 'core-home-tiles',
    templateUrl: './block-home-tiles.component.html',
})


export class BlockHomeTilesComponent extends BlockAbstractComponent implements OnInit, AfterViewInit {
    @ViewChild('tilesAnchor') tilesAnchor!: ElementRef<HTMLElement>;

    fragment?: string | null;

    categories$!: any;
    pillars = ['Healthy', 'Supported', 'Protected'];
    pillarsLowerCase = ['healthy', 'supported', 'protected'];
    otherCategories?: [PageCategory?];

    dynamicCategory?: string;
    dynamicPages?: [Page?];
    dynamicLoading?: boolean;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected cache: CacheService,
        private router: Router,
        private route: ActivatedRoute,
        public clientService: ClientService,
    ) {
        super(
            parser,
            auth
        );
    }

    ngAfterViewInit() {
        if (this.fragment === this.pillarsLowerCase[0]) {
            this.clientService.setTileIndex(0);
        }

        if (this.fragment === this.pillarsLowerCase[1]) {
            this.clientService.setTileIndex(1);
        }

        if (this.fragment === this.pillarsLowerCase[2]) {
            this.clientService.setTileIndex(2);
        }

        if (this.pillarsLowerCase.includes(<string> this.fragment)) {
            setTimeout(() => {
                this.tilesAnchor.nativeElement.scrollIntoView({
                    behavior: 'smooth'
                });
            }, 0);
        }
    }

    override ngOnInit() {
        super.ngOnInit();
        this.categories$ = this.cache.getListThroughCache('page-categories').pipe(
            tap((categories: [PageCategory]) => {
                this.otherCategories = [];
                categories.forEach((category) => {
                    if (!this.pillars.includes(category.name)) {
                        this.otherCategories!.push(category);
                    }
                    category.pagesLoading = true;
                    category.pages$ = this._loadCategoryPages(category);
                });
            })
        );

        this.route.fragment.subscribe(fragment => this.fragment = fragment);
    }

    pillarTabChange($event: { index: any; }) {
        const index = $event.index;

        if (index < 3) {
            window.history.replaceState({}, '', `#${this.pillarsLowerCase[index]}`);
        }
    }

    changeTab(tabIndex: number, category: PageCategory) {
        this.clientService.setTileIndex(tabIndex);
        this.dynamicLoading = true;
        this.dynamicPages = [];
        this.dynamicCategory = category.name;
        this._loadCategoryPages(category).subscribe((pages: [(Page | undefined)?] | undefined) => {
            this.dynamicLoading = false;
            this.dynamicPages = pages;
        });
    }

    private _loadCategoryPages(category: PageCategory) {
        return this.cache.getListThroughCache('pages', {
            q: JSON.stringify({parentId: 37}),
            includeBlocks: true
        }).pipe(
            tap((q) => {
                category.pagesLoading = false;
            })
        );
    }

    hasTileBlock(page: Page) {
        this.extractWidgets(page, page.widgets);
        return page.tile;
    }

    extractWidgets(page: Page, widgets: any[]) {
        widgets.forEach(widget => {
            if (widget.widgetId === WIDGET_ID) {
                page.tile = widget;
            }
            this.extractWidgets(page, widget.content);
        });
    }
}
